
/**
 * Format date to display in a readable format
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return 'No date';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { 
    weekday: 'short',
    month: 'short', 
    day: 'numeric' 
  });
};

/**
 * Format currency for display
 */
export const formatCurrency = (amount: number, options?: { showCents?: boolean }): string => {
  if (!amount && amount !== 0) return '--';
  
  const { showCents = true } = options || {};
  
  return amount.toLocaleString('en-US', { 
    style: 'currency', 
    currency: 'USD',
    minimumFractionDigits: showCents ? 2 : 0,
    maximumFractionDigits: showCents ? 2 : 0,
    useGrouping: true
  });
};

/**
 * Format text to Title Case, preserving internal capitalization
 * Only capitalizes the first letter of each word, leaving the rest unchanged
 */
export const formatToTitleCase = (text: string): string => {
  if (!text || typeof text !== 'string') return text;
  
  return text
    .split(' ')
    .map(word => {
      if (word.length === 0) return word;
      // Only capitalize the first letter, preserve the rest of the word's capitalization
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};

/**
 * Format number with comma thousand separators for display in input fields
 */
export const formatNumberWithCommas = (value: string): string => {
  // Remove any existing commas and non-numeric characters except decimal point
  const cleanValue = value.replace(/[^\d.]/g, '');
  
  // Split into integer and decimal parts
  const parts = cleanValue.split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1];
  
  // Add commas to integer part
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  // Reconstruct the number
  if (decimalPart !== undefined) {
    return `${formattedInteger}.${decimalPart}`;
  }
  
  return formattedInteger;
};

/**
 * Remove commas from a formatted number string
 */
export const removeCommasFromNumber = (value: string): string => {
  return value.replace(/,/g, '');
};
